module.exports = __webpack_public_path__ + "src/assets/textures/injection/vial_blue.png";